// extracted by mini-css-extract-plugin
export default {"lastTableCell":"AdditionalParameterRow_lastTableCell__UvA6Y"};